import React,{useState, useEffect} from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import {Tools} from './Tools';
import {Styles} from './Styles';
import Ajax from './Ajax';
import Create from './Create';

interface Props {
    uid:string,
    save(id:string):void,
    move(str:string):void,
}

interface Rank {
    name: string,
    point: number,
}

const Top = (props:Props)=> {
    Ajax.setUid(props.uid);
    const classes = Styles.base();
    const defRanks:Rank[] = [];
    const [states,setStates] = useState({
        modalPage:"",
        ranks: defRanks,
        sum: 0,
        isModal:false,
    })

    const handleModalClose = ()=>{
        setStates({...states,"isModal":false});
    };

    const openCreate = ()=>{
        setStates({...states,"modalPage":"create","isModal":true});
    }
    const close = ()=>{
        setStates({...states,"modalPage":"","isModal":false});
    }
    const start = (uid:string)=>{
        if( props.uid==="" ){
            props.save(uid);
        }
        props.move("board");
    }
    const config = ()=>{
        Ajax.send("config",{},(res:any)=>{
            //console.log("config",res);
        });
    }
    
    useEffect( ()=>{
        Ajax.send("rank/list",{},(res:any)=>{
            //console.log("rank",res);
            if( res.ok ){
                setStates({...states,"ranks":res.ranks,"sum":res.sum});
            }
        });
    },[]);

    return (
		<div id="top" className={classes.mainRoot}>
            <div style={{height:"100%",overflowY:"auto"}}>
                <Typography variant="subtitle2" style={{marginLeft:"1em"}}>部活動人気ランキング</Typography>
                <List
                    dense={true}
                    style={{lineHeight:"1em",marginBottom:"5em"}}
                >
                    {states.ranks.map((rank:Rank,index:number)=>{
                        const key = "rank"+index;
                        const r = String(index+1) + "位";
                        const second = rank.point + "人";
                        const per = String(Math.floor(rank.point / states.sum * 1000) / 10) + "%";
                        return (
                            <ListItem key={key} style={{borderTop:"1px solid silver"}}>
                                <ListItemIcon><span>{r}</span></ListItemIcon>
                                <ListItemText primary={rank.name} secondary={second} classes={{primary:classes.primary}}/>
                                <ListItemSecondaryAction>
                                    <span className={classes.secondary}>{per}</span>
                                </ListItemSecondaryAction>
                            </ListItem>
                        )
                    })}
                </List>
            </div>
            <div className={classes.bottomBar}>
                <Button variant="contained" color="primary" style={{width:"100%"}} onClick={openCreate}>はじめる</Button>
            </div>

            <Modal
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				open={states.isModal}
				onClose={handleModalClose}
			>
				<div style={Tools.getModalStyle()} className={classes.modal}>
                    <Create uid={props.uid} start={start} close={close}/>
	    		</div>
			</Modal>
            <Button variant="outlined" onClick={config} style={{display:"none",position:"absolute",bottom:"5em",right:"0"}}>CONFIG</Button>

		</div>
	);
}

export default Top;
